var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 479.18 479.12",
    style: {
      enableBackground: "new 0 0 479.18 479.12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M479.18,136.49c-0.36,9.51-6.48,17.67-15.46,23.97c-10.55,7.4-21.27,14.57-31.92,21.83c-25.6,17.45-51.19,34.9-76.81,52.3 c-1.61,1.09-2.19,2.04-1.76,4.12c11.18,53.51-2.02,100.2-39.42,140.03c-4.97,5.29-10.2,5.25-15.32,0.13 c-38.53-38.52-77.05-77.05-115.58-115.58c-27.36-27.36-54.71-54.72-82.07-82.07c-5.92-5.92-5.92-10.93,0.1-16.7 c23.89-22.91,52.24-36.77,85.02-41.28c17.55-2.41,35.08-1.77,52.41,2.15c2.24,0.51,3.21-0.46,4.34-2.05 c25.48-35.84,50.98-71.66,76.51-107.46c5.44-7.63,12.28-13.47,21.73-15.35c7.49-1.49,14.28,0.03,19.83,5.66 c37.5,38,75,75.99,112.49,114C477.15,124.14,479.11,128.94,479.18,136.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.97,266.86c18.23,17.94,36.37,35.8,54.72,53.87c-3.44,2.75-6.69,5.36-9.95,7.94 C140.6,377.89,78.46,427.09,16.35,476.34c-3.16,2.51-6.51,3.5-10.31,2.2c-6.05-2.06-7.98-9.41-3.82-14.83 c5.54-7.21,11.25-14.29,16.9-21.43c45.82-57.94,91.64-115.88,137.47-173.82C157.12,267.79,157.72,267.14,157.97,266.86z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinlogo);
export default __webpack_public_path__ + "static/media/pinlogo.7982fc36bf1287ebc5a3a018224e4141.svg";
export { ForwardRef as ReactComponent };